import React from 'react';
import { Layout } from '../ui/Layout';
import { Sidebar } from '../ui/Sidebar';
import { MapView } from '../map/MapView';
import { AnalyticsPanel } from '../analytics';
import { ShippingPanel } from '../shipping/ShippingPanel';
import { PayoutTable } from '../payout/PayoutTable';
import { LoadingOverlay } from '../ui/LoadingOverlay';
import { TourGuide } from '../tour/TourGuide';
import { CatastropheSelector } from '../CatastropheSelector';
import { useWeather } from '../../context';

export function MainLayout() {
  const { showPayoutTable, loading, loadingProgress, modelSelect } = useWeather();

  return (
    <Layout>
      <CatastropheSelector />
      <TourGuide />
      <Sidebar />
      <div className="flex-1 flex flex-col">
        {modelSelect === 'drought' ? (
          <AnalyticsPanel />
        ) : modelSelect === 'shipping' ? (
          <>
            <div className="flex-1 relative">
              <MapView />
              {loading && <LoadingOverlay progress={loadingProgress} />}
            </div>
            <div className="h-96 border-t border-[var(--border-color)]">
              <ShippingPanel />
            </div>
          </>
        ) : (
          <>
            <div className="flex-1 relative">
              <MapView />
              {loading && <LoadingOverlay progress={loadingProgress} />}
            </div>
            <AnalyticsPanel />
          </>
        )}
      </div>
      {showPayoutTable && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="glass-panel w-[600px] max-h-[80vh] overflow-y-auto p-6">
            <PayoutTable />
          </div>
        </div>
      )}
    </Layout>
  );
}